var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 1,
    fillRule: "evenodd",
    d: "M10.285 6.129A.395.395 0 0110.571 6h2.858c.097 0 .201.04.286.129a.54.54 0 01.142.371V7h-3.714v-.5a.54.54 0 01.142-.371zM8.143 7v-.5c0-.648.244-1.278.694-1.75A2.395 2.395 0 0110.571 4h2.858c.66 0 1.283.276 1.734.75a2.54 2.54 0 01.694 1.75V7H19a1 1 0 110 2h-1v9.5c0 .648-.245 1.278-.694 1.75a2.395 2.395 0 01-1.735.75H8.43c-.66 0-1.283-.276-1.735-.75A2.539 2.539 0 016 18.5V9H5a1 1 0 010-2h3.143zM8 9v9.5c0 .148.056.28.143.371a.395.395 0 00.286.129h7.142c.098 0 .202-.04.286-.129A.539.539 0 0016 18.5V9H8zm2.5 1.5a1 1 0 011 1v5a1 1 0 11-2 0v-5a1 1 0 011-1zm4 1a1 1 0 10-2 0v5a1 1 0 102 0v-5z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.255c2bce4d3e54c8c3637713b3dd606e.svg";
export { ForwardRef as ReactComponent };